import React from "react";
import { EditableHours } from "@activecollab/components";
import PropTypes from "prop-types";
import { useStopwatchContext } from "~/components/Timer/context";
import { stopwatchEditValidator } from "~/utils/utils";

const TickingElapsedTime = ({ hoursNotRunning, minutesNotRunning, id, onClick, onSave, onCancel }) => {
  const { hours, minutes, id: stopwatchId } = useStopwatchContext();

  return (
    <EditableHours
      className="tw-shrink-0"
      onClick={onClick}
      value={stopwatchId === id ? `${hours}:${minutes}` : `${hoursNotRunning}:${minutesNotRunning}`}
      onCancel={onCancel}
      onSave={onSave}
      validation={stopwatchEditValidator}
      variant="Body 2"
      weight="bold"
      data-testid="editable-hours"
    />
  );
};

TickingElapsedTime.propTypes = {
  id: PropTypes.number,
  onClick: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  hoursNotRunning: PropTypes.string,
  minutesNotRunning: PropTypes.string,
};

TickingElapsedTime.defaultProps = {
  onClick: () => null,
};

export default TickingElapsedTime;
